import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-grid">
          <div className="footer-column footer-column--logo">
            <div className="footer-column__head">
              <img src="/logo/logo.svg" alt="aivion" className="footer-logo" />
            </div>
          </div>

          <div className="footer-column">
            <div className="footer-column__head">
              <span className="footer-email">support@clowoow.ru</span>
            </div>

            <div className="footer-column__body">
              <h4 className="footer-column__title">Решения</h4>
              <button className="footer-link" type="button">
                Безопасность и контроль доступа
              </button>
              <button className="footer-link" type="button">
                Умное производство
              </button>
              <button className="footer-link" type="button">
                Аналитика персонала
              </button>
            </div>
          </div>

          <div className="footer-column">
            <div className="footer-column__head">
              <span className="footer-phone">8 800 000-00-00</span>
            </div>

            <div className="footer-column__body">
              <h4 className="footer-column__title">Информация</h4>
              <button className="footer-link" type="button">
                Результаты
              </button>
              <button className="footer-link" type="button">
                О компании
              </button>
              <button className="footer-link" type="button">
                Блог
              </button>
            </div>
          </div>

          <div className="footer-column footer-column--right">
            <div className="footer-column__head footer-column__head--right">
              <button type="button" className="footer-logout" onClick={handleLogout}>
                Выйти из кабинета
              </button>
            </div>

            <div className="footer-column__body footer-column__body--muted">
              <div className="footer-company__title">
                Реквизиты ООО «ПРОМЕТЕЙ»
              </div>
              <div className="footer-company__line">ИНН: 7848484949</div>
              <div className="footer-company__line">ОГРН: 3484494900340</div>
            </div>
          </div>

          <div className="footer-bottom">
            <button className="footer-link" type="button">
              Политика обработки cookies
            </button>
            <button className="footer-link" type="button">
              Политика обработки персональных данных
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

